import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { Field } from 'react-final-form';
import { getInputProps, getValidateFunction } from '../../../services/Validation';

/**
 * Wrapper around final-form's Field, that adds support for our Validation service
 */
export const FormField = ({ children, validators = [], label = '', ...otherProps }) => {
    const validate = useCallback(
        value => getValidateFunction(validators)(value, { label: label || undefined }),
        [validators, label]
    );
    const inputProps = useMemo(() => getInputProps(validators), [validators]);
    return (
        <Field validate={validate} {...otherProps}>
            {renderProps => children({ ...renderProps, input: { ...renderProps.input, ...inputProps } })}
        </Field>
    );
};

FormField.propTypes = {
    children: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    parse: PropTypes.func,
    format: PropTypes.func,
    value: PropTypes.any,
    label: PropTypes.string,
    isEqual: PropTypes.func,
    allowNull: PropTypes.bool,
    validators: PropTypes.arrayOf(
        PropTypes.shape({
            validate: PropTypes.func,
        })
    ),
};
